import { getFormFromLocalStorage } from "pages/home/utils";
import { IStep1FormValues } from "./iStep1FormValues";
import { useFormik } from "formik";
import { validations } from "./validations";

export interface UseStep1FormProps {
  onSubmit: (values: IStep1FormValues) => void;
  initialEmailValue: string;
}

export function useStep1Form(props: UseStep1FormProps) {
  const formFromLocalStorage = getFormFromLocalStorage();
  const form = useFormik<IStep1FormValues>({
    initialValues: {
      name: formFromLocalStorage?.name || "",
      email: formFromLocalStorage?.email || props.initialEmailValue || "",
      phone: formFromLocalStorage?.phone || "",
      position: formFromLocalStorage?.position || "",
      area: formFromLocalStorage?.area || "",
      subarea: formFromLocalStorage?.subarea || "",
      other_position: formFromLocalStorage?.other_position || "",
      other_area: formFromLocalStorage?.other_area || "",
    },
    validationSchema: validations,
    onSubmit: props.onSubmit,
  });

  return {
    ...form,
  };
}
